import { render, staticRenderFns } from "./Reservados.vue?vue&type=template&id=45f4b612&scoped=true"
import script from "./Reservados.vue?vue&type=script&lang=js"
export * from "./Reservados.vue?vue&type=script&lang=js"
import style0 from "./Reservados.vue?vue&type=style&index=0&id=45f4b612&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f4b612",
  null
  
)

export default component.exports